// src/config.js
import {
  trimTrailingSlash,
  buildBiosdkRawBaseUrl,
  buildBiosdkOperationUrl,
  getStoredIsoNamespace,
} from './biosdkRoutes';

const isDev = process.env.NODE_ENV !== 'production';

const defaultBiosdkBase = isDev
  ? 'http://localhost:9099/biosdk-service'
  : 'https://biosdk.credissuer.com/biosdk-service';

// Runtime configuration:
// `docker-entrypoint.sh` generates `/usr/share/nginx/html/config.js` and sets `window.RUNTIME_CONFIG`.
// This lets us change API base URLs without rebuilding the React bundle.
const runtimeConfig =
  (typeof window !== 'undefined' && window.RUNTIME_CONFIG) ? window.RUNTIME_CONFIG : {};

/**
 * Dev: same-origin path so setupProxy.js can forward to localhost:9098 (no CORS).
 * Production build (e.g. local `npm run build`): hosted demo URL unless overridden at build time.
 * Docker image sets REACT_APP_CONVERTER_API_BASE_URL=/biometrics-converter via Dockerfile ARG.
 */
const defaultConverterBase = isDev
  ? '/biometrics-converter'
  : 'https://biosdk.credissuer.com/biometrics-converter';

export const BIOSDK_API_BASE_URL =
  runtimeConfig.BIOSDK_API_BASE_URL ||
  process.env.REACT_APP_BIOSDK_API_BASE_URL ||
  defaultBiosdkBase;
export const BIOSDK_RAW_API_BASE_URL = buildBiosdkRawBaseUrl(BIOSDK_API_BASE_URL);

export const CONVERTER_API_BASE_URL =
  runtimeConfig.CONVERTER_API_BASE_URL ||
  process.env.REACT_APP_CONVERTER_API_BASE_URL ||
  defaultConverterBase;

/**
 * Single converter REST base.
 * Converter exposes endpoints directly under context path:
 *   /biometrics-converter/convertFromIsoFile
 *   /biometrics-converter/convertImageFileToIso
 */
export const CONVERTER_SINGLE_API_BASE = `${trimTrailingSlash(CONVERTER_API_BASE_URL)}`;

export const biosdkOperationUrl = (operationPath, isRaw = false) =>
  buildBiosdkOperationUrl(BIOSDK_API_BASE_URL, operationPath, isRaw, getStoredIsoNamespace());

export { logBiosdkUiRoute } from './biosdkRoutes';